import React, { useEffect, useState } from 'react';
import moment, { Moment } from 'moment';
import { Stack } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { CustomDateRangeValue } from 'modules/finance/sharedFilters';

interface Props {
  value: CustomDateRangeValue | null;
  onChange: (value: CustomDateRangeValue) => void;
}

const DATE_FORMAT = 'YYYY-MM-DD';

export const CustomDateRangeInputs = ({ value, onChange }: Props) => {
  // Draft state lets the inputs stay responsive while typing, without propagating
  // (and re-triggering the report query) until both dates are valid and from <= to.
  const [from, setFrom] = useState<Moment | null>(value?.from ? moment(value.from) : null);
  const [to, setTo] = useState<Moment | null>(value?.to ? moment(value.to) : null);

  useEffect(() => {
    setFrom(value?.from ? moment(value.from) : null);
    setTo(value?.to ? moment(value.to) : null);
  }, [value]);

  const commit = (nextFrom: Moment | null, nextTo: Moment | null) => {
    if (nextFrom?.isValid() && nextTo?.isValid() && !nextFrom.isAfter(nextTo)) {
      onChange({ from: nextFrom.format(DATE_FORMAT), to: nextTo.format(DATE_FORMAT) });
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Stack direction="row" spacing={1} alignItems="center">
        <DatePicker
          label="From"
          value={from}
          maxDate={to?.isValid() ? to : undefined}
          onChange={next => {
            setFrom(next);
            commit(next, to);
          }}
          slotProps={{ textField: { size: 'small', sx: { width: 150, fontSize: 12 } } }}
        />
        <DatePicker
          label="To"
          value={to}
          minDate={from?.isValid() ? from : undefined}
          onChange={next => {
            setTo(next);
            commit(from, next);
          }}
          slotProps={{ textField: { size: 'small', sx: { width: 150, fontSize: 12 } } }}
        />
      </Stack>
    </LocalizationProvider>
  );
};
